import React, { useEffect } from "react";
import { Hay2URoute } from "Route";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "contexts/AuthContext";
import { UserProvider } from "contexts/UserContext";
import { GalleryProvider } from "contexts/GalleryContext";
import { startOtelInstrumentation } from "./opentelemetry";
import GlobalErrorHandler from "./ErrorBoundary";
import { CartProvider } from "contexts/CartContext";
import { WishlistProvider } from "contexts/WishlistContext";
import { UnitProvider } from "contexts/UnitContext";
import { PusherProvider } from "contexts/PusherContext";
import { CookiesProvider } from "react-cookie";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

if (process.env.REACT_APP_INSTRUMENTED === "TRUE") {
  startOtelInstrumentation();
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App: React.FC = () => {
  return (
    <GlobalErrorHandler>
      <CookiesProvider>
        <GoogleOAuthProvider
          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}
        >
          <PayPalScriptProvider
            options={{
              clientId: process.env.REACT_APP_PAYPAL_ID as string,
            }}
          >
            <AuthProvider>
              <UserProvider>
                <PusherProvider>
                  <GalleryProvider>
                    <UnitProvider>
                      <CartProvider>
                        <WishlistProvider>
                          <Router>
                            <ScrollToTop />
                            <Hay2URoute />
                          </Router>
                        </WishlistProvider>
                      </CartProvider>
                    </UnitProvider>
                  </GalleryProvider>
                </PusherProvider>
              </UserProvider>
            </AuthProvider>
          </PayPalScriptProvider>
        </GoogleOAuthProvider>
      </CookiesProvider>
    </GlobalErrorHandler>
  );
};

export default App;
